import { render } from "./ProfileRatingStats.vue?vue&type=template&id=dd3c4f30&ts=true"
import script from "./ProfileRatingStats.vue?vue&type=script&lang=ts"
export * from "./ProfileRatingStats.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__